import { render, staticRenderFns } from "./house_ad.vue?vue&type=template&id=cfa6cbe2&scoped=true&"
var script = {}
import style0 from "./house_ad.vue?vue&type=style&index=0&id=cfa6cbe2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa6cbe2",
  null
  
)

export default component.exports